// extracted by mini-css-extract-plugin
module.exports = {"content":"Header_content__2MDyR","smallScreenOnly":"Header_smallScreenOnly__1WXqL"};